import { Homepage, Filings, VacationRentalsPageType, Employee } from '@arrived/models';

import { strapiApi } from '../api';

export async function getHomepage() {
  const response = await strapiApi.get<Homepage>(`/api/homepage?populate=deep`);
  return response.data;
}

export async function getVacationRentalsPage() {
  const response = await strapiApi.get<VacationRentalsPageType>(`/api/vacation-rental?populate=deep`);
  return response.data;
}

export async function getCircularLinks() {
  const response = await strapiApi.get<Filings>(`/api/offering-links?populate=deep`);
  return response.data;
}

export async function getPreviewPostBySlug(slug: string) {
  if (slug === '/') {
    const response = await strapiApi.get<Homepage>(`/api/homepage?populate=%2A&publicationState=preview`);
    return response.data;
  } else {
    // TODO: Create other page preview types
    return;
  }
}

export async function getEmployees() {
  const response = await strapiApi.get<{ data: Employee[] }>(`/api/employees?populate=deep&pagination[pageSize]=100`);
  return response.data;
}
